export default __webpack_public_path__ + "static/hero-image-c8545c497d4712d2f111a81f01478924.svg";